"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Radio;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _Input = require("./Input");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function Radio(props) {
  var boxProps = {
    className: (0, _utils.clsNames)('un-input-radio', props.vertical && '-vertical', props.sm && '-sm', !props.m0 && 'un-boxmargin', props.className)
  };
  var groupName = 'rg' + (0, _utils.uid)();
  var input = /*#__PURE__*/React.createElement("div", boxProps, props.options.map(function (o, x) {
    var label = (0, _utils.test)(o.text, o.name, o.label, typeof o === 'string' || typeof o === 'number' ? o : null);
    var checked = (0, _utils.test)(o.value, o.id, typeof o === 'string' || typeof o === 'number' ? o : null, x) === props.value;
    var inputProp = {
      type: 'radio',
      className: '_native',
      id: 'r' + (0, _utils.uid)(),
      value: (0, _utils.test)(o.value, o.id, x),
      name: groupName,
      checked: checked,
      onChange: function onChange() {
        return props.onChange && props.onChange(inputProp.value, o);
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      key: 'radio_' + x,
      className: (0, _utils.clsNames)('un-input-radio-item', checked && '-checked', props.r0 && x + 1 === props.options.length && '-r0')
    }, /*#__PURE__*/React.createElement("div", {
      className: "_icon"
    }, /*#__PURE__*/React.createElement("input", inputProp)), !(0, _utils.isEmpty)(label) && typeof label !== 'boolean' && /*#__PURE__*/React.createElement("label", {
      className: "_label",
      htmlFor: inputProp.id
    }, label), !!o.component && o.component);
  }), !props.form && !!props.label && (0, _Input.createInputboxLabel)(props.label, true, '-left'));
  if (props.form) return (0, _Input.createFormitem)(input, props);
  if (typeof props.classBox === 'string') return /*#__PURE__*/React.createElement("div", {
    className: props.classBox
  }, input);
  return input;
}